<template>
    <v-container v-if="editting">
        <v-row class="end" dense>
            <v-col md="1" cols="2">
                <v-tooltip v-if="editable && post.visible" top class="secondary-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            size="large"
                            @click.stop="hidePost"
                        >fas fa-eye-slash</v-icon>
                    </template>
                    <span>Hide Post</span>
                </v-tooltip>
                <v-tooltip v-else-if="editable && !post.visible" top class="secondary-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            size="large"
                            @click.stop="showPost"
                        >fas fa-eye</v-icon>
                    </template>
                    <span>Show Post</span>
                </v-tooltip>
            </v-col>
            <v-col md="1" cols="2">
                <v-tooltip top class="secondary-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            size="large"
                            @click.stop
                            v-if="editable"
                        >fas fa-trash</v-icon>
                    </template>
                    <span>Delete Post</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row class="center">
            <v-col cols="10">
                <v-text-field v-model="post.title" label="Post Title" outlined></v-text-field>
                <v-textarea
                    v-model="post.paragraph"
                    label="Post Paragraph"
                    outlined
                    hint="250 character limit"
                ></v-textarea>
                <site-button
                    :colNum="5"
                    :marginNumber="2"
                    @click-event="updatePost"
                    btnType="text"
                    text="Submit"
                    colorClasses="secondary-icon"
                    iconColor="primary-icon"
                ></site-button>
                <site-button
                    :colNum="5"
                    :marginNumber="2"
                    @click-event="closeEditor"
                    btnType="text"
                    text="Close"
                    colorClasses="secondary-icon"
                    iconColor="primary-icon"
                ></site-button>
            </v-col>
        </v-row>
    </v-container>
    <v-row
        dense
        v-else
        v-on="editable ? { click: openEditor } : {}"
        v-ripple
        class="timeline-row"
        :class="!post.visible ? 'invisible' : ''"
    >
        <v-col style="margin: auto; text-align: left;" cols="10">
            <h2>{{ post.title }}</h2>
            <p style="margin-left: 1em; margin-top: 1em;">{{ post.paragraph }}</p>
        </v-col>
        <v-col
            style="padding: 0px; text-align: right; display: flex; flex-direction: column;"
            cols="2"
        >
            <v-tooltip :nudge-left="40" bottom content-class="secondary-info-tooltip">
                <template v-slot:activator="{ on, attrs }">
                    <span
                        style="margin-bottom: auto; font-weight: bold; font-size: 8pt;"
                        v-bind="attrs"
                        v-on="on"
                    >{{ formatDate(post.createdAt) }}</span>
                </template>
                <span>Authored By {{ post.author }}</span>
            </v-tooltip>
            <div style="margin-top: auto; margin-bottom: 0.5em;">
                <v-row class="end">
                    <v-col cols="4">
                        <v-tooltip v-if="editable && post.visible" top class="secondary-tooltip">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    size="large"
                                    @click.stop="hidePost"
                                >fas fa-eye-slash</v-icon>
                            </template>
                            <span>Hide Post</span>
                        </v-tooltip>
                        <v-tooltip
                            v-else-if="editable && !post.visible"
                            top
                            class="secondary-tooltip"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    size="large"
                                    @click.stop="showPost"
                                >fas fa-eye</v-icon>
                            </template>
                            <span>Show Post</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="4">
                        <v-tooltip top class="secondary-tooltip">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    size="large"
                                    @click.stop
                                    v-if="editable"
                                >fas fa-trash</v-icon>
                            </template>
                            <span>Delete Post</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import moment from 'moment'
import SiteButton from '../common/SiteButton.vue'

export default {
    name: 'post-list-item',
    components: {
        'site-button': SiteButton,
    },
    props: {
        editable: {
            type: Boolean,
            default: false,
        },
        isNew: {
            type: Boolean,
            default: false,
        },
        propPost: {
            type: Object,
            default: () => {},
        },
        index: {
            type: Number,
            default: undefined,
        },
    },
    data: () => ({
        editting: false,
        initialPost: null,
        post: null,
    }),
    created() {
        if (this.isNew) this.editting = true
        this.post = JSON.parse(JSON.stringify(this.propPost))
        this.initialPost = JSON.parse(JSON.stringify(this.propPost))
    },
    methods: {
        updatePost() {
            this.$emit('update-post', this.index, this.post)
            this.editting = false
            this.initialPost = JSON.parse(JSON.stringify(this.post))
        },
        closeEditor() {
            console.log(this.propPost)
            this.post = this.initialPost
            this.editting = false
            if (this.isNew) this.$emit('delete-post', this.index)
        },
        hidePost() {
            this.post.visible = false;
            this.$emit('update-post', this.index, { ...this.post, visible: false });
        },
        showPost() {
            this.post.visible = true
            this.$emit('update-post', this.index, { ...this.post, visible: true });
        },
        removePost() {},
        openEditor() {
            console.log('editting')
            this.editting = true
        },
        formatDate(date) {
            return moment(date).format('MM.DD.YYYY H a')
        },
    },
}
</script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.deal-card {
    width: 150px;
    min-height: 150px;
    padding: 0.5em;
    border-radius: 5px;
}

.deal-card.morning {
    background-color: rgba(255, 176, 107, 0.15);
    outline: rgb(255, 176, 107) solid 3px;
}

.deal-card.noon {
    background-color: rgba(238, 29, 0, 0.15);
    outline: rgb(238, 29, 0) solid 3px;
}

.deal-card.evening {
    background-color: rgba(0, 0, 109, 0.15);
    outline: rgb(0, 0, 109) solid 3px;
}
</style>